import React from 'react';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineContent } from '@mui/lab';
import { ComplianceRequirement, ComplianceEvent, ComplianceStatus } from '../types/compliance';
import { Typography } from '@mui/material';

interface ComplianceTimelineProps {
  requirement: ComplianceRequirement | null;
  onClose: () => void;
  onUpdate: (change: any) => Promise<void>;
  isOpen: boolean;
}

export const ComplianceTimeline: React.FC<ComplianceTimelineProps> = ({
  requirement,
  onClose,
  onUpdate,
  isOpen
}) => {
  // Helper function to determine the color based on status
  const getStatusColor = (status: ComplianceStatus) => {
    switch (status) {
      case ComplianceStatus.COMPLIANT:
        return 'success';
      case ComplianceStatus.NON_COMPLIANT:
        return 'error';
      case ComplianceStatus.AT_RISK:
        return 'warning';
      default:
        return 'primary';
    }
  };

  return (
    <Timeline>
      {requirement && requirement.events.map((event: ComplianceEvent, index: number) => (
        <TimelineItem key={index}>
          <TimelineSeparator>
            <TimelineDot color={getStatusColor(event.status)} />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="h6">{event.type}</Typography>
            <Typography>{event.description}</Typography>
            <Typography variant="caption">
              {new Date(event.date).toLocaleDateString()}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}; 